export enum SocketEvent {
  TodaysPriceChangeUpdate = 'todaysPriceChangeUpdate',
}
